import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', message }) => {
  const { t } = useTranslation('common');
  const resolvedMessage = message ?? t('loadingSpinner.defaultMessage');
  return (
    <div className={`loading-spinner-container ${size}`} role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true"></div>
      <span className="loading-message">{resolvedMessage}</span>
    </div>
  );
};

export default LoadingSpinner;
